import './AccountRecover.css';
import logo from '../../assets/images/logo.svg';
import { useNavigate, useLocation } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { axiosInstance } from '../../config/axiosConfig';
import loaderService from '../../service/loaderService';
import { showError, showSuccess } from '../../service/toastService';
import { useState } from 'react';
import { CONFIRM_SIGNUP, RESEND_CONFIRMATION_CODE } from '../../config/endpoint';

const AccountRecover = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const emailFromLocation = state?.email || '';

  const [otpSent, setOtpSent] = useState(false);

  const schema = yup.object().shape({
    email: yup.string().email('Invalid email format').required('Email is required'),
    ...(otpSent && {
      confirmationCode: yup
        .string()
        .required('OTP is required')
        .matches(/^\d{6}$/, 'OTP must be 6 digits'),
    }),
  });

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      email: emailFromLocation,
      confirmationCode: '',
    },
  });

  const onSubmit = async (data) => {
    loaderService.show();
    try {
      if (!otpSent) {
        // Send OTP
        const res = await axiosInstance.post(RESEND_CONFIRMATION_CODE, { email: data.email });
        if (res?.data?.CodeDeliveryDetails) {
          setOtpSent(true);
          showSuccess('OTP sent to your email.');
        } else {
          showError('Failed to send OTP. Please try again.');
        }
      } else {
        // Verify OTP
        await axiosInstance.post(CONFIRM_SIGNUP, data);
        showSuccess('Your email is confirmed. Please try to login.');
        setTimeout(() => navigate('/login'), 3000);
      }
    } catch (err) {
      showError(err?.response?.data?.message || 'Something went wrong');
    } finally {
      loaderService.hide();
    }
  };

  return (
    <div className="forgot">
      <div className="py-32">
        <img src={logo} alt="logo" />
      </div>
      <div className="forgot_form_container">
        <div className="forgot_form">
          <div className="heading">
            Recover Your Account <b>brainyagent.ai</b>
          </div>
          <form
            className="w-100 gap-16 d-flex flex-column"
            autoComplete="off"
            onSubmit={handleSubmit(onSubmit)}
          >
            <div>
              <div className="input-container">
                <label htmlFor="email">Email Address</label>
                <input
                  id="email"
                  type="email"
                  className="input"
                  {...register('email')}
                  placeholder="Enter your email"
                  disabled={otpSent}
                />
              </div>
              {errors.email && <p className="error-message">{errors.email.message}</p>}
            </div>

            {otpSent && (
              <div>
                <div className="input-container">
                  <label htmlFor="confirmationCode">Enter OTP</label>
                  <input
                    id="confirmationCode"
                    type="text"
                    className="input"
                    {...register('confirmationCode')}
                    placeholder="Enter the 6-digit OTP"
                  />
                </div>
                {errors.confirmationCode && (
                  <p className="error-message">{errors.confirmationCode.message}</p>
                )}
              </div>
            )}

            <button type="submit" className="theme-sky-btn" disabled={isSubmitting}>
              {otpSent ? 'Verify OTP' : 'Send OTP'}
            </button>

              <p className="color-white fw-light text-center">
                Remembered?{" "}
                <span
                  className="text-decoration-underline cursor-pointer"
                  onClick={() => navigate('/login')}
                >
                  Go to Login
                </span>
              </p>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AccountRecover;
